import { jsx as _jsx } from "react/jsx-runtime";
import { IconMap2 } from "@tabler/icons-react";
const iconMap = {
    basemap: IconMap2,
};
export const LayerGroupIcon = ({ icon }) => {
    if (!icon) {
        return null;
    }
    const Icon = iconMap[icon];
    if (!Icon) {
        return null;
    }
    return _jsx(Icon, { size: 16, stroke: 1.5 });
};
